module.exports = __webpack_public_path__ + "static/img/code.06d2c75.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/code.jpg
// module id = gl+v
// module chunks = 1